export default __webpack_public_path__ + "static/media/starFilled_small.3532979b.svg";